import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'evalScript',
    standalone: true,
})
export class EvalScriptPipe implements PipeTransform {  
  transform(value?: any, args?: any) {
    setTimeout(() => {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = value?.changingThisBreaksApplicationSecurity;
      const scripts = wrapper?.getElementsByTagName('script');
      Array.from(scripts)?.forEach(function (script) {
        window.eval(script.innerHTML);
      });
    }, 500);
    return value;
  }
}
